<div class="grid-container mat-elevation-z10">
    <div class="" fxLayout="row" fxLayoutAlign="space-between" style="padding: 10px 30px 30px">
      <h3>Ultimo Stato</h3>
    </div>
    <div class="" style="overflow-x: auto">
      <!--(matSortChange)="onTableClicked(data)" (matSortChange)="sortData($event)" row.delivery_category_item.type.tipologia {{getCellValue(row, column) }}-->
      <table mat-table [dataSource]="this.data"  aria-describedby="events tables">
        <ng-container matColumnDef="device_timestamp">
            <th mat-header-cell *matHeaderCellDef>
              {{ "smart-bin-events.grid.column.device_timestamp" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.device_timestamp | date:'dd/MM/yyyy, HH:mm:ss'  }}
            </td>
        </ng-container>
        <ng-container matColumnDef="event_type">
            <th mat-header-cell *matHeaderCellDef>
              {{ "smart-bin-events.grid.column.event_type"  | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.event_type_id__description }}
            </td>
        </ng-container>
        <ng-container matColumnDef="notes">
          <th mat-header-cell *matHeaderCellDef>
            {{ "smart-bin-events.grid.column.notes"  | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.notes }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  
        <tr class="mat-row w-100" *matNoDataRow>
          <td [attr.colspan]="displayedColumns.length" class="mat-cell mat-cell-no-data text-center">
          </td>
        </tr>
      </table>
    </div>
</div>

